var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{attrs:{"id":'complex_canvas'+_vm.element.id,"width":"500","height":"500"}})])}
var staticRenderFns = []

export { render, staticRenderFns }